'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight, MapPin, Gift, Ticket } from 'lucide-react';
import { useSession } from '@/lib/auth-client';
import { SignInEmailStart } from '@/components/auth/SignInEmailStart';
const highlights = [{
  icon: Gift,
  label: 'Offers & freebies'
}, {
  icon: Ticket,
  label: 'Tastings & events'
}, {
  icon: MapPin,
  label: 'New Products'
}];
const packagedImages = [{
  src: 'https://images.unsplash.com/photo-1742972459942-aed536c720cf?auto=format&fit=crop&fm=jpg&q=80&w=600&h=600',
  alt: 'Packaged chips and branded snack bags on a retail shelf'
}
// {
//   src: 'https://images.unsplash.com/photo-1755752919046-a6543db419cc?auto=format&fit=crop&fm=jpg&q=80&w=600&h=600',
//   alt: 'Energy drink cans and bottled beverages lined up on shelves',
// },
// {
//   src: 'https://images.unsplash.com/photo-1761059080249-3f0fe21958a5?auto=format&fit=crop&fm=jpg&q=80&w=600&h=600',
//   alt: 'Packaged bottled drinks arranged in a convenience store fridge',
// },
// {
//   src: 'https://images.unsplash.com/photo-1749648537909-67e35a37fbbb?auto=format&fit=crop&fm=jpg&q=80&w=600&h=600',
//   alt: 'Convenience store shelf of packaged drinks with canned snacks in the foreground',
// },
];
export function ConsumerFastTrackV3() {
  const $ = _c(11);
  const {
    data: session
  } = useSession();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute -right-20 -top-20 h-64 w-64 rounded-full bg-primary-100/40 blur-3xl" />;
    t1 = <div className="absolute -bottom-16 -left-16 h-48 w-48 rounded-full bg-amber-100/50 blur-2xl" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-primary-600">For people</p>;
    t3 = <h2 className="mb-4 text-2xl font-extrabold leading-tight text-gray-900 sm:text-3xl">Discover your next thing to try, love, and come back to</h2>;
    t4 = <p className="mx-auto mb-6 max-w-md text-base text-gray-600 sm:text-lg md:mx-0">Browse offers, tastings, events, and new products from brands all over the country, and turn first discovery into everyday favourites.</p>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mb-8 flex flex-wrap justify-center gap-3 md:justify-start">{highlights.map(_temp)}</div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== session) {
    t6 = <div className="flex-1 text-center md:text-left">{t2}{t3}{t4}{t5}{!session ? <><SignInEmailStart buttonLabel="Get VIP Access" className="mb-6 w-full max-w-lg md:mx-0 mx-auto" /><Link href="/opportunities" className="inline-flex cursor-pointer items-center gap-1 text-sm font-medium text-gray-500 transition-colors hover:text-primary-600">or explore first<ArrowRight className="h-3.5 w-3.5" /></Link></> : <Link href="/opportunities" className="group inline-flex cursor-pointer items-center gap-2 rounded-full bg-primary-600 px-7 py-3.5 text-base font-bold text-white shadow-lg shadow-primary-200/50 transition-all hover:bg-primary-700 hover:shadow-xl">Explore<ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" /></Link>}</div>;
    $[6] = session;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="hidden w-40 shrink-0 grid-cols-1 gap-4 md:grid lg:w-80">{packagedImages.map(_temp2)}</div>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6) {
    t8 = <section className="relative overflow-hidden bg-gradient-to-r from-orange-50 via-rose-50 to-amber-50">{t0}{t1}<div className="container relative z-10 mx-auto px-4 py-20 sm:px-6 lg:px-8 lg:py-20"><div className="mx-auto flex max-w-5xl flex-col items-center gap-10 md:flex-row md:gap-16">{t6}{t7}</div></div></section>;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
}
function _temp2(img, i) {
  return <div key={img.src} className={`aspect-square overflow-hidden rounded-2xl shadow-md ring-1 ring-black/5 ${i === 1 ? "translate-y-3" : i === 2 ? "-translate-y-3" : ""}`}><img src={img.src} alt={img.alt} className="h-full w-full object-cover" loading="lazy" /></div>;
}
function _temp(t0) {
  const {
    icon: Icon,
    label
  } = t0;
  return <span key={label} className="inline-flex items-center gap-1.5 rounded-full bg-white/80 px-3 py-1.5 text-sm font-medium text-gray-700 shadow-sm ring-1 ring-gray-200/60"><Icon className="h-3.5 w-3.5 text-primary-500" />{label}</span>;
}